import { RestClient } from '@libs/rest-client';
import {
  hoMstDelete,
  hoMstExport,
  hoMstFetch,
  hoMstImport,
  hoMstListRequest,
  hoMstRegistration,
  hoMstUpdate,
} from '@libs/templates/mst';
import {
  BusinessConnectionMstListSearchRaw,
  BusinessConnectionMstRegistration,
  BusinessConnectionMstRegistrationRaw,
  BusinessConnectionMstSetting,
  BusinessConnectionMstSettingRaw,
} from '../models';

const BUSINESS_CONNECTION_MST_URL = '/business-connection-mst';

const register = hoMstRegistration(BUSINESS_CONNECTION_MST_URL, BusinessConnectionMstRegistrationRaw)();

const listRequest = hoMstListRequest(
  BUSINESS_CONNECTION_MST_URL,
  BusinessConnectionMstListSearchRaw,
  BusinessConnectionMstRegistration,
)();

const doExport = hoMstExport(BUSINESS_CONNECTION_MST_URL, BusinessConnectionMstListSearchRaw)();

const fetchMst = hoMstFetch(BUSINESS_CONNECTION_MST_URL, BusinessConnectionMstRegistration)();

const update = hoMstUpdate(BUSINESS_CONNECTION_MST_URL, BusinessConnectionMstRegistrationRaw)();

const remove = hoMstDelete(BUSINESS_CONNECTION_MST_URL)();

const importFunction = hoMstImport(BUSINESS_CONNECTION_MST_URL)();

async function fetchBusinessConnectionMstSetting() {
  return BusinessConnectionMstSetting.fromRaw(
    await RestClient.fa.get<BusinessConnectionMstSettingRaw>(`${BUSINESS_CONNECTION_MST_URL}/setting`),
  );
}

async function registerSetting(model: BusinessConnectionMstSetting) {
  await RestClient.fa.put(
    `${BUSINESS_CONNECTION_MST_URL}/setting`,
    BusinessConnectionMstSettingRaw.fromModel(model),
  );
}

export {
  doExport,
  fetchBusinessConnectionMstSetting,
  fetchMst,
  importFunction,
  listRequest,
  register,
  registerSetting,
  remove,
  update,
};
